import { oneOf, bool, node } from 'prop-types'
import { TransitionGroup, CSSTransition } from 'react-transition-group'
import { kuiperClassNames } from '../utils'
import './styles.scss'

const SlideOutPanel = ({
  children,
  side = 'left',
  visible = false,
  theme = '250',
}) => (
  <TransitionGroup
    className={kuiperClassNames(
      'slide-out-panel-transition-group',
      `width-${theme}`,
      side
    )}
  >
    {visible && (
      <CSSTransition classNames="kuiper-slide" timeout={150}>
        <div className={kuiperClassNames('slide-out-panel')}>{children}</div>
      </CSSTransition>
    )}
  </TransitionGroup>
)

SlideOutPanel.propTypes = {
  children: node,
  side: oneOf(['left', 'right']),
  theme: oneOf(['250', '350']),
  visible: bool,
}

export default SlideOutPanel
